<dx-box direction="col" width="100%" height="100%" [ngClass]="{ 'cc-hidden': !routeComplete }">
    <dxi-item [ratio]="1">
        <ng-container *ngIf="isAuthenticated; else notAuthorized">
            <ng-container *ngIf="isPopup(); else notPopup">
                <router-outlet></router-outlet>
            </ng-container>
        </ng-container>
    </dxi-item>
</dx-box>

<ng-template #notPopup>
    <ng-container *ngIf="!isLoginUrl(); else notAuthorized">
        <app-side-nav-outer-toolbar #appOuterSideNav [title]="appTitle">
            <router-outlet (activate)="onActivate($event)"></router-outlet>
        </app-side-nav-outer-toolbar>
    </ng-container>
</ng-template>

<ng-template #notAuthorized>
    <div class="application-container" [ngClass]="{ 'cc-application-background': !isPopup() }">
        <router-outlet></router-outlet>
    </div>
</ng-template>

<cc-message-box #messageBox></cc-message-box>

<dx-load-panel
    *ngIf="(isLoginUrl() && isAuthenticated) || loadingVisible"
    [position]="{ of: 'body' }"
    [visible]="(isLoginUrl() && isAuthenticated) || loadingVisible"
    [delay]="0"
></dx-load-panel>

<div id="fullscreen-container" class="cc-hidden-box fullscreen-container cc-grey-background"></div>
